import React, { useState } from 'react';
import moment from 'moment';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/trades';

const bloodlines = ['Areo', 'Darley', 'Hayato',"Byerley","Godolphin","Blood"];

const clsLvs = [1, 2, 3, 4, 5, 6];

const ListTrades = () => {
  const filter = {};
  const [status, setStatus] = useState('');
  const [currency, setCurrency] = useState('');

  const aCond = [];

  if (status) {
    aCond.push({ status });
  }
  if (currency) {
    aCond.push({ currency });
  }
  if (aCond.length > 0) {
    filter.$and = aCond;
  }

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        actions: {
          create: false,
          fileExport: true,
        },
        sort: { createdAt: -1 },
        filter,
        cols: [
          {
            key: 'createdAt',
            sortable: true,
            childres: 'Created At',
            getter(v) {
              return v ? moment(v).format('YYYY/MM/DD hh:mm:ss') : '';
            },
          },
          { key: 'status', sortable: true, childres: 'Status' },
          {
            key: 'address',
            sortable: true,
            children: 'Address',
            getter(v) {
              return `${v.slice(0, 6)}..${v.slice(-6)}`;
            },
          },
          {
            key: 'mint',
            sortable: true,
            children: 'Mint',
            getter(v) {
              return `${v.slice(0, 6)}..${v.slice(-6)}`;
            },
          },

          {
            key: 'seller',
            sortable: true,
            childres: 'Seller',
            getter(v) {
              return `${v.slice(0, 6)}..${v.slice(-6)}`;
            },
          },
          { key: 'price', sortable: true, childres: 'Price' },
          { key: 'currency', sortable: true, childres: 'Currency' },
          // { key: 'horsePics.src', sortable: true, children: 'Pics' },
        ],
        ctrls: [
          <select
            className="custom-select"
            key={0}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">All</option>
            {['For Sale', 'Completed', 'Canceled'].map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>,
          <select
            className="custom-select"
            key={1}
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
          >
            <option value="">All</option>
            {['DGE', 'USDC'].map((a) => (
              <option key={a} value={a}>
                ${a}
              </option>
            ))}
          </select>,
        ],
      }}
    >
      {({ selected, refresh }) => (
        <ListCtrlActivates api={api} selected={selected} onSuccess={refresh} />
      )}
    </ListResource>
  );
};

export default ListTrades;
